import PieLabel from './pie-label.component';
export default PieLabel;
